module.exports = __webpack_public_path__ + "static/media/11.d8f25d77.jpg";